import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
import {
    getUsers,
    getUserDetail,
    putUser,
    postUser,
    putUserStatus,
    putPasswordForUser,
    putUserPassword,
    getBrvUsers
} from './userAPI';

const initialState = {
    users: undefined,
    brvUsers: undefined,
    detail: undefined,
    status: {
      users: 'idle',
      brvUsers: 'idle',
      detail: 'idle',
    },
    error: undefined,
};

export const getUsersAsync = createAsyncThunk(
    'users',
    async (params, thunkAPI) => {
      try{
        const response = await getUsers(params);
        // The value we return becomes the `fulfilled` action payload
        return response.data;
      } catch(error){
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
);
export const getBrvUsersAsync = createAsyncThunk(
    'brvUsers',
    async (params, thunkAPI) => {
      try{
        const response = await getBrvUsers(params);
        // The value we return becomes the `fulfilled` action payload
        return response.data;
      } catch(error){
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
);
export const getUserDetailAsync = createAsyncThunk(
    'userDetail',
    async (id, thunkAPI) => {
      try{
        const response = await getUserDetail(id);
        // The value we return becomes the `fulfilled` action payload
        return response.data;
      } catch(error){
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
);
export const postUserAsync = createAsyncThunk(
    'postUser',
    async (data, thunkAPI) => {
      try{
        const response = await postUser(data);
        return response.data;
      } catch(error){
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
);
export const putUserAsync = createAsyncThunk(
    'putUser',
    async (data, thunkAPI) => {
      try{
        const response = await putUser(data);
        return response.data;
      } catch(error){
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
);
export const putUserStatusAsync = createAsyncThunk(
    'putUserStatus',
    async (data, thunkAPI) => {
      try{
        const response = await putUserStatus(data.id, data.values);
        return response.data;
      } catch(error){
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
);
export const putUserPasswordAsync = createAsyncThunk(
    'putUserPassword',
    async (data, thunkAPI) => {
      try{
        const response = await putUserPassword(data);
        localStorage.removeItem("auth")
        localStorage.removeItem("token")
        window.location.replace("/")
        return response.data;
      } catch(error){
        return thunkAPI.rejectWithValue(error.response)
      }
    }
);
export const putPasswordForUserAsync = createAsyncThunk(
    'putPasswordForUser',
    async (data, thunkAPI) => {
      try{
        const response = await putPasswordForUser(data.id, data.values);
        return response.data;
      } catch(error){
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
);
  
export const userSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
      setIdleStatus: (state, action) => {
        if(action.payload){
          let [key] = Object.keys(action.payload)
          state.status[key] = action.payload[key]
        }
      },
      clearUserDetail: state => {
        state.detail = undefined;
      },
      clearUsers: state => {
        state.users = undefined;
      },
      clearBrvUsers: state => {
        state.brvUsers = undefined;
      }
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
      builder
        .addCase(getUsersAsync.pending, (state) => {
          state.status.users = 'loading';
        })
        .addCase(getUsersAsync.fulfilled, (state, action) => {
          state.users = action.payload
          state.status.users = 'idle';
          state.error = undefined;
        })
        .addCase(getUsersAsync.rejected, (state, action) => {
          state.status.users = 'idle';
          if(action?.error?.name !== "AbortError"){
            message.error("Lấy dữ liệu thất bại!")
            state.error = {
              payload: action.payload,
              title: "getUsers"
            }
          }
        })
        .addCase(getBrvUsersAsync.pending, (state) => {
          state.status.brvUsers = 'loading';
        })
        .addCase(getBrvUsersAsync.fulfilled, (state, action) => {
          state.brvUsers = action.payload.data.map(user => ({
            id: user.EmployeeCode,
            key: user.EmployeeCode,
            label: user.EmployeeName,
            name: user.EmployeeName,
          }))
          state.status.brvUsers = 'idle';
          state.error = undefined;
        })
        .addCase(getBrvUsersAsync.rejected, (state, action) => {
          state.status.brvUsers = 'idle';
          if(action?.error?.name !== "AbortError"){
            message.error("Lấy dữ liệu thất bại!")
            state.error = {
              payload: action.payload,
              title: "getUsers"
            }
          }
        })
        .addCase(getUserDetailAsync.pending, (state) => {
          state.status.detail = 'loading';
        })
        .addCase(getUserDetailAsync.fulfilled, (state, action) => {
          state.detail = action.payload
          state.status.detail = 'idle';
          state.error = undefined;
        })
        .addCase(getUserDetailAsync.rejected, (state, action) => {
          state.status.detail = 'idle';
          if(action?.error?.name !== "AbortError"){
            message.error("Lấy dữ liệu thất bại!")
            state.error = {
              payload: action.payload,
              title: "getUser"
            }
          }
        })
        .addCase(postUserAsync.pending, (state) => {
          state.status.detail = 'loading';
        })
        .addCase(postUserAsync.fulfilled, (state, action) => {
          state.detail = action.payload
          state.status.detail = 'done';
          state.error = undefined;
        })
        .addCase(postUserAsync.rejected, (state, action) => {
          state.status.detail = 'idle';
          if(action?.error?.name !== "AbortError"){
            if(action?.payload?.response?.field === "brv_code"){
              if(action?.payload?.response?.message === "Duplicated"){ 
                message.error("Mã Bravo đã được sử dụng")
              }
            }
            else{
              message.error("Tạo người dùng thất bại!")
            }
            state.error = {
              payload: action.payload,
              title: "postUser"
            }
          }
        })
        .addCase(putUserAsync.pending, (state) => {
            state.status.detail = 'update_loading';
        })
        .addCase(putUserAsync.fulfilled, (state, action) => {
          state.detail = action.payload
          message.success("Cập nhật thành công!")
          state.status.detail = 'done';
          state.error = undefined;
        })
        .addCase(putUserAsync.rejected, (state, action) => {
          state.status.detail = 'idle';
          if(action?.error?.name !== "AbortError"){
            message.error("Cập nhật thất bại!")
            state.error = {
              payload: action.payload,
              title: "putUser"
            }
          }
        })
        .addCase(putUserStatusAsync.pending, (state) => {
          state.status.detail = 'update_status_loading';
        })
        .addCase(putUserStatusAsync.fulfilled, (state, action) => {
          state.detail = action.payload
          state.status.detail = 'done';
          state.error = undefined;
        })
        .addCase(putUserStatusAsync.rejected, (state, action) => {
          state.status.detail = 'idle';
          if(action?.error?.name !== "AbortError"){
            message.error("Thay đổi trạng thái thất bại!")
            state.error = {
              payload: action.payload,
              title: "putUserStatus"
            }
          }
        })
        .addCase(putUserPasswordAsync.pending, (state) => {
          state.status.detail = 'update_password_loading';
        })
        .addCase(putUserPasswordAsync.fulfilled, (state, action) => {
          state.detail = action.payload
          state.status.detail = 'done';
          state.error = undefined;
        })
        .addCase(putUserPasswordAsync.rejected, (state, action) => {
          state.status.detail = 'idle';
          if(action?.error?.name !== "AbortError"){
            if(action?.payload?.status === 403){
              const data = action.payload.data[0]
              if(data.message === "Incorrect password"){
                message.error("Mật khẩu hiện tại không đúng!")  
              }
            }
            else{
              message.error("Thay đổi mật khẩu thất bại!")
            }
            state.error = {
              payload: action.payload,
              title: "putUserPassword"
            }
          }
        })
        .addCase(putPasswordForUserAsync.pending, (state) => {
          state.status.detail = 'update_other_password_loading';
        })
        .addCase(putPasswordForUserAsync.fulfilled, (state, action) => {
          // state.detail = action.payload
          state.status.detail = 'done';
          state.error = undefined;
        })
        .addCase(putPasswordForUserAsync.rejected, (state, action) => {
          state.status.detail = 'idle';
          if(action?.error?.name !== "AbortError"){
            message.error("Thay đổi mật khẩu thất bại!")
            state.error = {
              payload: action.payload,
              title: "putOtherUserPassword"
            }
          }
        })
    },
});

export const selectUsers = state => state.users.users
export const selectBrvUsers = state => state.users.brvUsers
export const selectUserDetail = state => state.users.detail
export const usersStatus = state => state.users.status
export const usersError = state => state.users.error

export const { clearUserDetail, clearUsers, setIdleStatus, clearBrvUsers } = userSlice.actions;
  
export default userSlice.reducer;
  
